export { default as RestaurantExtraInfo } from './RestaurantExtraInfo'
export { default as RestaurantExtraInfoSkeleton } from './Skeleton'
